import React, { FunctionComponent } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { PermissionType } from '@companion-professional/dctypes';
import { usePermissions } from '../../state/auth';

interface PermissionProtectedRoutesProps {
  // allowPermissions is a list of permissions; the user must hold at least one of them to access the routes.
  allowPermissions: PermissionType[];

  // redirectPath is the path the user is sent to if they hold none of the permissions.
  redirectPath: string;
}

// PermissionProtectedRoutes can be used in a react-router Routes component to protect encapsulated routes based on the
// user's permissions.  This looks something like this in practice:
//
// <Routes>
//   <Route path="/" element={<Home />} />
//   <Route element={<PermissionProtectedRoutes allowPermissions={['checkup.review']} redirectPath="/" />}>
//     <Route path="/protected" element={<SuperSecret />} />
//   </Route>
// </Routes>
//
// NOTE: this should not be used to enforce any kind of security.  It is purely for UI purposes; the backend enforces
// access.
export const PermissionProtectedRoutes: FunctionComponent<PermissionProtectedRoutesProps> = ({
  allowPermissions,
  redirectPath
}) => {
  const permissions = usePermissions();

  if (permissions.some((permission) => allowPermissions.includes(permission))) {
    return <Outlet />;
  }

  return <Navigate to={redirectPath} />;
};
